/* Japan Motor Import theme — theme.js (no dependencies). Collection filter: assets/collection-filter.js */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };

  function money(cents) {
    var fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withComma).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ',')).replace(/<[^>]+>/g, '');
  }
  function handle(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function toast(msg) {
    var t = $('#CartToast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._tm); t._tm = setTimeout(function () { t.hidden = true; }, 2600);
  }

  var menu = $('#MobileMenu');
  $$('[data-menu-toggle]').forEach(function (b) {
    on(b, 'click', function () {
      var open = menu.hidden; menu.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
      var burger = $('.header__burger'); if (burger) burger.setAttribute('aria-expanded', open);
    });
  });

  var pin = $('[data-predictive-input]'), pres = $('[data-predictive-results]');
  if (pin && pres && theme.routes.predictive) {
    var ptm;
    on(pin, 'input', function () {
      clearTimeout(ptm);
      var q = pin.value.trim();
      if (q.length < 2) { pres.hidden = true; pres.innerHTML = ''; return; }
      ptm = setTimeout(function () {
        fetch(theme.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var html = '';
            var cols = (d.resources.results.collections || []);
            var prods = (d.resources.results.products || []);
            cols.forEach(function (c) { html += '<a href="' + c.url + '"><span>' + c.title + '</span><span class="predictive__price">Category</span></a>'; });
            prods.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_80x80$1$2') + '" alt="">' : '';
              html += '<a href="' + p.url + '">' + img + '<span>' + p.title + (p.variants && p.variants[0] && p.variants[0].sku ? ' <small style="color:#71717a">#' + p.variants[0].sku + '</small>' : '') + '</span><span class="predictive__price">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
            });
            html += '<a class="predictive__all" href="' + theme.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">View all results →</a>';
            pres.innerHTML = html; pres.hidden = false;
          }).catch(function () { pres.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.header__search')) pres.hidden = true; });
  }

  (function () {
    var p = location.pathname.replace(/\/+$/, '');
    if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/shop$/i.test(p)) {
      location.replace(((window.theme && theme.routes && theme.routes.all) || '/collections/all') + location.search);
    }
  })();

  function vehicleData() {
    if (vehicleData._d) return vehicleData._d;
    var raw = {}, el = document.getElementById('VehicleData');
    try { raw = el ? JSON.parse(el.textContent) : {}; } catch (e) { raw = {}; }
    var makes = [], byHandle = {};
    function addMake(name) {
      name = String(name || '').trim(); var h = handle(name); if (!h) return null;
      if (!byHandle[h]) { byHandle[h] = { name: name, handle: h, models: [], seen: {} }; makes.push(byHandle[h]); }
      return byHandle[h];
    }
    function addModel(mk, name) {
      name = String(name || '').trim(); var h = handle(name); if (!mk || !h || mk.seen[h]) return;
      mk.seen[h] = 1; mk.models.push({ name: name, handle: h });
    }
    (raw.lines || []).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 0) { addMake(line); return; }
      var mk = addMake(line.slice(0, i));
      line.slice(i + 1).split(',').forEach(function (m) { addModel(mk, m); });
    });
    (raw.vendors || []).forEach(addMake);
    (raw.tags || []).forEach(function (t) { var p = String(t).split(':'); if (p.length > 1) addModel(addMake(p[0]), p.slice(1).join(':')); });
    makes.forEach(function (m) { m.models.sort(function (a, b) { return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }); }); });
    vehicleData._d = { makes: makes, byHandle: byHandle, yearMin: raw.yearMin || 1980, yearMax: raw.yearMax || new Date().getFullYear() };
    return vehicleData._d;
  }
  function fillModelSelect(sel, makeHandle, placeholder, selected) {
    if (!sel) return;
    var vd = vehicleData(), mk = vd.byHandle[makeHandle];
    sel.innerHTML = '';
    sel.appendChild(new Option(placeholder, ''));
    if (mk) mk.models.forEach(function (m) { sel.appendChild(new Option(m.name, m.handle)); });
    if (selected) {
      sel.value = selected;
      if (sel.value !== selected) { sel.appendChild(new Option(selected.replace(/-/g, ' ').toUpperCase(), selected)); sel.value = selected; }
    }
  }
  function fillMakeSelect(sel) {
    var vd = vehicleData(); if (!sel || !vd.makes.length) return;
    var ph = sel.options[0] ? sel.options[0].textContent : '';
    sel.innerHTML = '';
    sel.appendChild(new Option(ph, ''));
    vd.makes.forEach(function (m) { sel.appendChild(new Option(m.name, m.handle)); });
  }

  var finder = $('[data-finder]');
  if (finder) {
    var fYear = $('[data-finder-year]', finder), fMake = $('[data-finder-make]', finder), fModel = $('[data-finder-model]', finder);
    var fModelPh = fModel && fModel.options[0] ? fModel.options[0].textContent : '';
    fillMakeSelect(fMake);
    if (fYear && fYear.options.length <= 1) {
      var vdy = vehicleData();
      for (var yy = vdy.yearMax; yy >= vdy.yearMin; yy--) fYear.appendChild(new Option(yy, yy));
    }
    on(fMake, 'change', function () { fillModelSelect(fModel, fMake.value, fModelPh); fModel.disabled = !fMake.value; });
    on(finder, 'submit', function (e) {
      e.preventDefault();
      var p = new URLSearchParams();
      if (fYear && fYear.value) p.set('year', fYear.value);
      if (fMake && fMake.value) p.set('make', fMake.value);
      if (fModel && fModel.value) p.set('model', fModel.value);
      var qs = p.toString();
      window.location.href = finder.getAttribute('action') + (qs ? '?' + qs : '');
    });
  }

  /* Shared with assets/collection-filter.js */
  window.JMI = { vehicleData: vehicleData, fillModelSelect: fillModelSelect, fillMakeSelect: fillMakeSelect, handle: handle };

  var gal = $('[data-gallery]');
  if (gal) {
    var slides = $$('.gallery__slide', gal), thumbs = $$('[data-thumb]', gal), idx = 0;
    var lb = $('[data-lightbox]'), lbImg = lb ? $('.lightbox__img', lb) : null;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      if (lb && !lb.hidden) { var img = $('img', slides[idx]); if (img) lbImg.src = img.dataset.zoom || img.currentSrc || img.src; }
    }
    thumbs.forEach(function (t) { on(t, 'click', function () { show(+t.dataset.thumb); }); });
    $$('[data-gallery-prev]').forEach(function (b) { on(b, 'click', function () { show(idx - 1); }); });
    $$('[data-gallery-next]').forEach(function (b) { on(b, 'click', function () { show(idx + 1); }); });
    var openLb = function () { if (!lb) return; var img = $('img', slides[idx]); if (!img) return; lbImg.src = img.dataset.zoom || img.currentSrc || img.src; lb.hidden = false; document.body.style.overflow = 'hidden'; };
    on($('[data-lightbox-open]'), 'click', openLb);
    slides.forEach(function (s) { on($('img', s), 'click', openLb); });
    on($('[data-lightbox-close]'), 'click', function () { lb.hidden = true; document.body.style.overflow = ''; });
    on(lb, 'click', function (e) { if (e.target === lb) { lb.hidden = true; document.body.style.overflow = ''; } });
    document.addEventListener('keydown', function (e) { if (lb && !lb.hidden) { if (e.key === 'Escape') { lb.hidden = true; document.body.style.overflow = ''; } if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); } });
    var sx = 0; on($('.gallery__main', gal), 'touchstart', function (e) { sx = e.touches[0].clientX; });
    on($('.gallery__main', gal), 'touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-minus],[data-qty-plus]'); if (!b) return;
    var box = b.closest('.qty__box'), inp = $('input', box), v = parseInt(inp.value || '1', 10);
    v += b.hasAttribute('data-qty-plus') ? 1 : -1;
    var min = parseInt(inp.min || '0', 10), max = inp.max ? parseInt(inp.max, 10) : Infinity;
    inp.value = Math.max(min, Math.min(max, v));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var pform = $('[data-product-form]');
  if (pform && $('[data-variants]', pform)) {
    var variants = JSON.parse($('[data-variants]', pform).textContent);
    $$('[data-option-select]', pform).forEach(function (sel) {
      on(sel, 'change', function () {
        var chosen = $$('[data-option-select]', pform).map(function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        $('input[name=id]', pform).value = v.id;
        $('[data-price]').innerHTML = money(v.price) + ' <small>' + ($('[data-price] small') ? $('[data-price] small').textContent : '') + '</small>';
        var btn = $('[data-add-to-cart]', pform); btn.disabled = !v.available; $('span', btn).textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      });
    });
  }

  if (pform) {
    on(pform, 'submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-to-cart]', pform), label = $('span', btn);
      btn.disabled = true; label.textContent = theme.strings.adding;
      fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: $('input[name=id]', pform).value, quantity: parseInt($('input[name=quantity]', pform).value || '1', 10) }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) { toast(d.description || d.message); return; }
          toast(theme.strings.added);
          return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { var cnt = $('[data-cart-count]'); if (cnt) { cnt.textContent = c.item_count; cnt.hidden = c.item_count === 0; } });
        })
        .catch(function () { pform.submit(); })
        .then(function () { btn.disabled = false; label.textContent = theme.strings.addToCart; });
    });
    on($('[data-buy-now]'), 'click', function () {
      fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: $('input[name=id]', pform).value, quantity: parseInt($('input[name=quantity]', pform).value || '1', 10) }) })
        .then(function () { window.location.href = '/checkout'; });
    });
    on($('[data-calc-shipping]'), 'click', function (e) {
      // Put the item in the cart first so the estimator has something to quote.
      e.preventDefault();
      var a = e.currentTarget;
      fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
        var has = c.items.some(function (i) { return String(i.variant_id) === a.dataset.variant; });
        if (has) { window.location.href = a.href; return; }
        return fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: a.dataset.variant, quantity: 1 }) }).then(function () { window.location.href = a.href; });
      });
    });
  }

  var rec = $('[data-recommendations]');
  if (rec && !rec.querySelector('.card')) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'); var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.querySelector('.card')) rec.innerHTML = inner.innerHTML; else rec.remove();
    });
  }

  $$('[data-line-qty]').forEach(function (inp) {
    on(inp, 'change', function () {
      fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: inp.dataset.lineQty, quantity: parseInt(inp.value, 10) }) }).then(function () { location.reload(); });
    });
  });
  $$('[data-line-remove]').forEach(function (a) {
    on(a, 'click', function (e) { e.preventDefault(); fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: a.dataset.lineRemove, quantity: 0 }) }).then(function () { location.reload(); }); });
  });
  var est = $('[data-estimator]');
  if (est) {
    on($('[data-est-submit]', est), 'click', function () {
      var out = $('[data-est-results]', est); out.innerHTML = '…';
      var q = 'shipping_address[country]=' + encodeURIComponent($('[data-est-country]', est).value) + '&shipping_address[province]=' + encodeURIComponent($('[data-est-province]', est).value) + '&shipping_address[zip]=' + encodeURIComponent($('[data-est-zip]', est).value);
      fetch(theme.routes.cart + '/shipping_rates.json?' + q).then(function (r) { return r.json(); }).then(function (d) {
        var rates = d.shipping_rates || [];
        if (!rates.length) { out.textContent = (document.documentElement.lang === 'fr') ? 'Aucun tarif de livraison trouvé pour cette adresse.' : 'No shipping rates found for that address.'; return; }
        out.innerHTML = '<ul>' + rates.map(function (r) { return '<li><span>' + r.name + '</span><strong>' + money(Math.round(parseFloat(r.price) * 100)) + '</strong></li>'; }).join('') + '</ul>';
      }).catch(function () { out.textContent = 'Could not calculate shipping.'; });
    });
    if (location.hash === '#shipping-estimate') est.scrollIntoView({ behavior: 'smooth' });
  }

  on($('[data-recover-toggle]'), 'click', function (e) { e.preventDefault(); var r = $('#recover'); r.hidden = !r.hidden; });
  $$('[data-address-toggle]').forEach(function (b) { on(b, 'click', function () { var el = document.getElementById(b.dataset.addressToggle); el.hidden = !el.hidden; }); });
  $$('[data-address-delete]').forEach(function (b) { on(b, 'click', function () { if (confirm('Delete this address?')) { var f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.addressDelete; f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit(); } }); });
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
})();